import LivestockCalculationDetails from './LivestockShrinkCalculationDetails'

export default LivestockCalculationDetails
